<template>
  <div id="repair-create-after">
    <component v-bind:is="imgComponent" v-bind:repairRecord.sync="repairRecord">
    </component>
  </div>
</template>

<script>
import RepairCreateAfterPicture from './repair-create-after-picture.vue';
import RepairCreateAfterSwiper from './repair-create-after-swiper.vue';
const img_map = new Map([
  [true, { component: 'RepairCreateAfterPicture' }],
  [false, { component: 'RepairCreateAfterSwiper' }]
]);
export default {
  components: { RepairCreateAfterSwiper, RepairCreateAfterPicture },
  props: {
    repairRecord: {
      type: Object,
      default: () => ({})
    },
    visibleEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    imgComponent() {
      const { component } = img_map.get(this.visibleEdit);
      return component;
    }
  }
};
</script>

<style lang="scss"></style>
